// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner_banner__sge2e","banner_icon":"banner_banner_icon__ZMJ0L","banner_title":"banner_banner_title__wqsBg"};